import { createReducer } from '@reduxjs/toolkit';
import {
  setSelectedCarpetSort,
  setOmsIdFromUrl,
  setLoadMoreVisible,
  setLoadMoreToggle
} from '../actions/actionCreators';
import { SortCarpetBy } from '../utils/constants';

export const initialState = {
  selectedCarpetSort: SortCarpetBy.Popularity,
  omsIdFromUrl: null,
  loadMoreVisible: null,
  loadMoreToggle: true,
};

export const mandiMore = createReducer(initialState,
  (builder) => builder
    .addCase(setSelectedCarpetSort, (state, action) => ({
      ...state,
      selectedCarpetSort: action.selectedCarpetSort,
      omsIdFromUrl: null,
    }))
    .addCase(setLoadMoreVisible, (state, action) => ({ ...state, loadMoreVisible: action.payload }))
    .addCase(setLoadMoreToggle, (state, action) => ({ ...state, loadMoreToggle: action.payload }))
    .addCase(setOmsIdFromUrl, (state, action) => ({ ...state, omsIdFromUrl: action.payload }))
);
